// extracted by mini-css-extract-plugin
export default {"friend-list":"OnboardingFbFriendsList--friend-list--YYoDc","friendList":"OnboardingFbFriendsList--friend-list--YYoDc"};